import axios from "axios";

export const getAllCategoriesFromDB = () =>
  axios.get(`${process.env.REACT_APP_API_URL}/categories`);
